import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import { IconX } from '@tabler/icons-react'
import ImageBrowse from "../../../../Common/Image/ImageBrowse";
import { _showToast } from "../../../../../toastHelper";
  
  const Subpeoplemenu = forwardRef(function PopularImages(props, ref) {
  const [people, setPeople] = useState({
        peopleData: { facebook: '', twitter: '', linkedin: '', instagram: '' },
        
      });
    const [name, setName] = useState("");
      const [date, setDate] = useState("");
    const [isOpen, setIsOpen] = useState("");   
  const [errors, setErrors] = useState({});
   const [imageKey, setImageKey] = useState(null);
      const imageRef = useRef();
      const imageRef1 = useRef();
      const [file3, setFile3] = useState(null);
      const handleChange = (bannerKey, field, value) => {
        setPeople(prev => ({
          ...prev,
          [bannerKey]: {
            ...prev[bannerKey],
            [field]: value
          }
        }));
      };
  
  
    useEffect(() => {
      setIsOpen(props.data.show);
    }, [props.data.show]);
  
  
    const validate = () => {
      const errors = {};
  
      if (!name || (name && name.trim() == "")) {
        errors.name = "Name is required";
      }
  
      setErrors(errors);
      return Object.keys(errors).length === 0;
    }
  
    const getData = () => {
      const data = {
        name,
        date,
        peopleData: people,
        image1: imageRef?.current?.getThumbnail() ?? null,
        imageFile1: imageRef?.current?.getImageFile() ?? null,
        image2: imageRef1?.current?.getThumbnail() ?? null,
        imageFile2: imageRef1?.current?.getImageFile() ?? null,
        imageKey1: imageKey,
      };
    
      if (props.section) {
        props.section(data, props.index);
      }
    
      return data;
    };
    
    
  
    
    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));
  
    return (
      <div className="card accordion-item ">
        <h2 className="accordion-header">
          <button type="button"
            onClick={() => props.showHidePople(props.index)}
            className={`accordion-button ${isOpen ? "" : "collapsed"}`}>
            {name}
          </button>
        </h2>
  
     
  
         <form>
            <div className="row g-3">
              <div className="col-sm-6">
                <label className="form-label" htmlFor="section2Name">
                People Name
                </label>
                <input
                  type="text"
                  id="section2Name"
                  name="section2Name"
                  placeholder="Please enter the main title here"
                  className={`form-control ${errors.name ? "is-invalid" : ""
                    }`}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              
              </div>
              <div className="col-sm-6">
                <label className="form-label" htmlFor="section2Name">
                People role
                </label>
                <input
                  type="text"
                  id="section2Name"
                  name="section2Name"
                  placeholder="Please enter the main title here"
                  className={`form-control ${errors.date ? "is-invalid" : ""
                    }`}
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
               
              </div>
              <div className="col-sm-6">
                <label className="form-label" htmlFor="section2Name">
                People Facebook
                </label>
                <input
                  type="text"
                  id="section2Name"
                  name="section2Name"
                  placeholder="Please enter the main title here"
                  className={`form-control `}
                    value={people.peopleData.facebook}
                    onChange={(e) => handleChange("peopleData","facebook",e.target.value)}
                    />
               
              </div>
              <div className="col-sm-6">
                <label className="form-label" htmlFor="section2Name">
                People Twitter
                </label>
                <input
                  type="text"
                  id="section2Name"
                  name="section2Name"
                  placeholder="Please enter the main title here"
                  className={`form-control`}
                    value={people.peopleData.twitter}
                    onChange={(e) => handleChange("peopleData","twitter",e.target.value)}
                />
               
              </div>
              <div className="col-sm-6">
                <label className="form-label" htmlFor="section2Name">
                People Linkedin
                </label>
                <input
                  type="text"
                  id="section2Name"
                  name="section2Name"
                  placeholder="Please enter the main title here"
                  className={`form-control `}
                  value={people.peopleData.linkedin}
                  onChange={(e) => handleChange("peopleData","linkedin",e.target.value)}
                  />
                
              </div>
              <div className="col-sm-6">
                <label className="form-label" htmlFor="section2Name">
                People Instagram
                </label>
                <input
                  type="text"
                  id="section2Name"
                  name="section2Name"
                  placeholder="Please enter the main title here"
                  className={`form-control `}
                    value={people.peopleData.instagram}
                    onChange={(e) => handleChange("peopleData","instagram",e.target.value)}
                />
                
              </div>
  
              <div className="col-sm-6">
  <div className="row">
    <div>
      <label className="form-label" htmlFor="image">
        Image 1 <small className="text-gray">(750px x 750px)</small>
      </label>
      <ImageBrowse
        elementId={`peopleImage1-${props.index}`}
        ref={imageRef}
        imageType="people1"
        imageKey={imageKey}
        setImageKey={setImageKey}
        imageDelete={props.imageDelete}
      />
    </div>
  </div>
</div>

<div className="col-sm-6">
  <div className="row">
    <div>
      <label className="form-label" htmlFor="image">
        Image 2 <small className="text-gray">(750px x 750px)</small>
      </label>
      <ImageBrowse
        elementId={`peopleImage2-${props.index}`}
        ref={imageRef1}
        imageType="people2"
        imageKey={imageKey}
        setImageKey={setImageKey}
        imageDelete={props.imageDelete}
      />
    </div>
  </div>
</div>

             
            </div>
          </form>
      </div>
    )
  });
  
  export default Subpeoplemenu;
  